<!-- right zone on desktop -->
<div class="left-column" [class.sticky]="!isMobile" #content>
    <ng-content select="[leftColumn]"></ng-content>
</div>

<!-- left zone on desktop -->
<div class="right-column" #stickyWrapper>
    <ng-content select="[rightColumn]"></ng-content>
</div>
